<template lang="pug">
  section.section
    .columns
      .column.is-half
        b-field(horizontal label="共有書店コード" v-if="persisted")
          | {{ final_book_shop.shop_code }}
        b-field(horizontal label="共有書店コード" v-else class="required")
          b-field(:type="{'is-danger': errors.has('final_book_shop.shop_code')}" :message="errors.first('final_book_shop.shop_code')")
            b-input(v-model="final_book_shop.shop_code" type="text" name="final_book_shop.shop_code" v-validate="'required'" data-vv-as="共有書店コード")
      .column.is-half
        b-field(horizontal label="売上ランキング")
          | {{ final_book_shop.ranking }}
    .columns
      .column.is-half
        b-field(horizontal label="書店名(漢字)" class="required")
          b-field(:type="{'is-danger': errors.has('final_book_shop.name')}" :message="errors.first('final_book_shop.name')")
            b-input(v-model="final_book_shop.name" type="text" name="final_book_shop.name" v-validate="'required'" id="book_shop_name" data-vv-as="書店名(漢字)")
      .column.is-half
        b-field(horizontal label="書店名(ふりがな)" class="required")
          b-field(:type="{'is-danger': errors.has('final_book_shop.name_kana')}" :message="errors.first('final_book_shop.name_kana')")
            b-input(v-model="final_book_shop.name_kana" type="text" name="final_book_shop.name_kana" v-validate="'required'" id="book_shop_name_kana" data-vv-as="書店名(ふりがな)")
    .columns
      .column.is-half
        b-field(horizontal label="グループ名")
          b-input(v-model="final_book_shop_group.shop_name" name="final_book_shop_group.shop_name" type="text" v-validate="" id="shop_name" data-vv-as="グループ名")
      .column.is-half
        b-field(horizontal label="グループコード")
          b-input(v-model="final_book_shop.group_code" type="text" name="final_book_shop.group_code" v-validate="" id="group_code" data-vv-as="グループコード")
    .columns
      .column.is-half
        b-field(horizontal expanded label="都道府県")
          b-input(v-model="final_book_shop.prefecture_name" type="text" name="final_book_shop.prefecture_name" v-validate="" id="prefecture_name")
          b-field(horizontal expanded label="郵便番号")
            b-input(v-model="final_book_shop.zip_code" type="text" name="final_book_shop.zip_code" v-validate="" id="zip_code")
      .column.is-half
          b-field(horizontal label="閉店区分")
            b-input(v-model="final_book_shop.closed_classification" type="text" name="final_book_shop.closed_classification" v-validate="" id="closed_classification")
    .columns
      .column.is-half
        b-field(horizontal label="主住所")
          b-input(v-model="final_book_shop.main_address" type="text" name="final_book_shop.main_address" v-validate="" id="main_address")
      .column.is-half
        b-field(horizontal label="閉店年月")
          b-input(v-model="final_book_shop.closed_yyyymm" type="text" name="final_book_shop.closed_yyyymm" v-validate="" id="closed_yyyymm")
    .columns
      .column.is-half
        b-field(horizontal label="副住所")
          b-input(v-model="final_book_shop.sub_address" type="text" name="final_book_shop.sub_address" v-validate="" id="sub_address")
    .columns
      .column.is-half
        b-field(horizontal label="電話番号")
          b-input(v-model="final_book_shop.telephone" type="text" name="final_book_shop.telephone" v-validate="" id="telephone")
    .columns
      .column.is-one-fifth
        label.label 取次コード
      .column.is-one-fifth
        label.label 取次書店コード
      .column.is-one-fifth
        label.label VAN
      .column.is-one-fifth
        label.label 番線
      .column.is-one-fifth
        label.label 使用区分
      .column(v-if="final_book_shop_agencies.length == 0")
        button(@click="addRow" class="button is-info")
          b-icon(pack="fas" custom-class="fa-sm fa-plus")
    .columns(v-for="(final_book_shop_agency, index) in final_book_shop_agencies")
      .column.is-one-fifth
        b-select(v-model="final_book_shop_agency.agency_code" name="final_book_shop_agency.agency_code" type="text" :id="`agency_code${index}`")
          option(
              v-for="agency in agencies"
              :value="agency.code"
              :key="agency.code")
            | {{ agency.code + " " + agency.name }}
      .column.is-one-fifth
        b-input(v-model="final_book_shop_agency.agency_shop_code" name="final_book_shop_agency.agency_shop_code" type="text" v-validate="" :id="`agency_shop_code${index}`")
      .column.is-one-fifth
        b-input(v-model="final_book_shop_agency.agency_van_name" name="final_book_shop_agency.agency_van_name" type="text" v-validate="" :id="`agency_van_name${index}`")
      .column.is-one-fifth
        b-input(v-model="final_book_shop_agency.book_sorting_work_code" name="final_book_shop_agency.book_sorting_work_code" type="text" v-validate="" :id="`book_sorting_work_code${index}`")
      .column.is-one-fifth
        b-input(v-model="final_book_shop_agency.used_classification" name="final_book_shop_agency.used_classification" type="text" v-validate="" :id="`used_classification${index}`")
      .column
        button(@click="addRow" class="button is-info" v-show="lastBookShopAgencyIndex == index")
          b-icon(pack="fas" custom-class="fa-sm fa-plus")
    .columns
      template(v-if="persisted")
        .column.is-two-thirds
        .column
          .field.is-horizontal
            .field-label.is-normal
              .label 自動削除
            .field-body
              .field
                .control
                  b-checkbox(v-model="final_book_shop.lock_update" name="final_book_shop.lock_update")
                    | しない
                  p.help.is-danger （ ※3ヶ月更新されない場合データが自動的に削除されます ）

    .columns.is-centered
      .column.is-half
        .field
          .control
            button(@click="submit" class="button is-medium is-danger is-fullwidth")
              | {{ buttonLabel }}
</template>

<script>
  import CacheDispatcher from 'mixins/cache_dispatcher'

  export default {
    name: 'final-book-shop-table',
    mixins: [CacheDispatcher],
    $_veeValidate: {
      validator: 'new'
    },
    data() {
      return {
        final_book_shop: {},
        final_book_shop_groups: {},
        final_book_shop_group: {},
        final_book_shop_agencies: [],
      }
    },
    props: {
      final_book_shop_id: {
        type: Number,
        required: false
      },
    },
    computed: {
      users(){ return this.$store.getters['Users/records'] },
      agencies(){ return this.$store.getters['Agencies/records'] },
      lastBookShopAgencyIndex() { return this.final_book_shop_agencies.length - 1 },
      buttonLabel() { return this.final_book_shop_id ? '更新する' : '登録する'},
      persisted() { return !!this.final_book_shop_id }
    },
    methods: {
      userName(id){
        if (!id) return ''
        let tmp = this.users
            .filter(user => user.id == id)
        if(tmp.length == 0)
          return ''
        return tmp[0].name
      },
      formatTime(time) {
        return this.$moment(time).format("YYYY.MM.DD hh:mm")
      },
      submitRequest(){
        var method = this.final_book_shop_id ? 'patch' : 'post'
        var url = this.final_book_shop_id ? `/api/v1/final_book_shops/${this.final_book_shop_id}.json` : '/api/v1/final_book_shops.json'

        this.final_book_shop.edit_book_shop_agencies_attributes = this.final_book_shop_agencies
        this.final_book_shop_group.group_code = this.final_book_shop.group_code
        if(!this.final_book_shop_id)
          this.final_book_shop.lock_update = true

        var params = {
          edit_book_shop: this.final_book_shop,
          edit_book_shop_group: this.final_book_shop_group
        }
        return this.$http({ method: method, url: url, data: params })
      },
      submitFinalBookShopGroup() {
        let method = 'patch'
        var url = `/api/v1/final_book_shop_groups/${this.final_book_shop_group.id}.json`
        var params = {
          edit_book_shop_group: this.final_book_shop_group,
          shop_code: this.final_book_shop.shop_code
        }
        return this.$http({ method: method, url: url, data: params })
      },
      submit(){
        this.loading = true
        this.$validator.validate('*').then((result) => {
          if (result) {
            this.submitRequest().then(({data}) => {
              this.loading = false
              this.$toast.open({
                message: '登録情報が変更されました。',
                type: 'is-success',
                position: 'is-top'
              })
              window.location.href = `/users/final_book_shops/${data.final_book_shop.id}`
            })
            .catch((error) => {
              this.loading = false
              this.$toast.open({
                message: '登録情報エラーです。登録情報を確認してください。',
                type: 'is-danger',
                position: 'is-top'
              })
            })
            return
          }
          this.loading = false
          this.$toast.open({
            message: '登録情報エラーです。登録情報を確認してください。',
            type: 'is-danger',
            position: 'is-top'
          })
        });
      },
      addRow() {
        this.final_book_shop_agencies.push(Object.assign({
          agency_code: null, agency_shop_code: null, agency_van_name: null, book_sorting_work_code: null, used_classification: null
        }))
      },
      addRequiredText() {

        // [].slice.call => HtmlCollectionを配列に変換
        let required_labels = [].slice.call(document.getElementsByClassName('required')).map(e => e.children[0])
        required_labels.forEach((label) => {
          let span = document.createElement('span')
          let textNode = document.createTextNode('(*必須)')
          span.appendChild(textNode)
          span.classList.add('has-text-danger')

          label.appendChild(span)
        })
      }
    },
    mounted(){
      if(this.final_book_shop_id) {
        this.$http.get(`/api/v1/final_book_shops/${this.final_book_shop_id}.json`)
            .then(({data}) => {
              this.final_book_shop = data.final_book_shop
              this.$http.get(`/api/v1/final_book_shop_agencies`, { params: { q: { shop_code_eq: this.final_book_shop.shop_code } } })
                  .then(({data}) => {
                    this.final_book_shop_agencies = data.final_book_shop_agencies
                  })
              this.$http.get(`/api/v1/final_book_shop_groups`, { params: { group_code: this.final_book_shop.group_code, shop_code: this.final_book_shop.shop_code } })
                  .then(({data}) => {
                    if(data.results.length == 1)
                      this.final_book_shop_group = data.results[0]
                  })
            })
            .catch((error) => {
              this.final_book_shop = []
              this.final_book_shop_agencies = []
              this.final_book_shop_group = []
              throw error
            })
      }
      this.$store.dispatch('Users/fetch', 'users')
      this.dispatch_with_cache('Agencies/fetch', 'agencies', this.agencies)

      this.addRequiredText()
    }
  }
</script>